export default {
    contractForm: {
        editTitle: 'Uredi pogodbo',
        newTitle: 'Nova pogodba',
        saveRejected: 'Shranjevanje zavrnjeno',
        counterparty: 'Nasprotna stranka',
        counterpartyEic: 'EIC nasprotne stranke',
        externalDealId: 'Zunanji ID posla',
        country: 'Država',
        side: 'Stran',
        productType: 'Vrsta izdelka',
        tenor: 'Ročnost',
        deliveryPeriod: 'Obdobje dobave',
        from: 'OD',
        to: 'DO',
        profileSource: 'Vir profila',
        internalReference: 'Interna referenca',
        internalReferencePlaceholder: 'PO / vstopnica / prosto besedilo',
        tradeDate: 'Datum trgovanja',
        attachments: 'Priloge',
        attachmentsHint: 'Prilepite URL-je dokumentov (PDF / e-pošta / Excel) — do 20 na pogodbo.',
        mtuFill: 'MTU polnjenje (MW)',
        price: 'Cena (€/MW)',
        currency: 'Valuta',
        customHelperNote: 'Predali bodo nastavljeni na zaslonu urejevalnika po Naprej.',
        reclassifyHint: 'Državo je mogoče ponovno klasificirati (HR ↔ SI). Sprememba ponovno razreši profil.',
        reclassifyNote: 'Ponovna klasifikacija {from} → {to} ponovno razreši profil te pogodbe po novem tržnem koledarju (drugačen nabor koničnih/praznikov) in premakne njeno pozicijo med knjigami držav. Zahteva pravice za odobritev.',
        dateLockedNote: 'Obsega dobave za pogodbo MANUAL_BILATERAL ni mogoče spremeniti — njeni predali so vezani na to okno. Za drugačen obseg ustvarite novo pogodbo.',
        mtuFillCustomHint: 'Ročno nastavite predale v urejevalniku.',
        mtuFillActiveHint: 'Vsak aktivni {productType} MTU je nastavljen na to vrednost. Skupno se izračuna samodejno.',
        overlapDetected: 'Zaznano prekrivanje obveznosti',
        submitting: 'Pošiljanje…',
        saveChanges: 'Shrani spremembe',
        continue: 'Naprej →',
        selectCountry: 'Izberite HR ali SI',
        counterpartyRequired: 'Nasprotna stranka je obvezna',
        startDateRequired: 'Datum začetka je obvezen',
        endDateRequired: 'Datum konca je obvezen',
        endAfterStart: 'Datum konca mora biti na ali po datumu začetka',
        mtuFillPositive: 'MTU polnjenje mora biti večje od nič',
        pricePositive: 'Cena mora biti večja od nič',
        amendContractIdRequired: 'način spreminjanja zahteva lastnost contractId ali initial.id',
        unknownError: 'Neznana napaka',
        contractAmended: 'Pogodba spremenjena',
        contractCreated: 'Pogodba ustvarjena',
    },
}
